import { createReducer } from '@reduxjs/toolkit'

export type CompareValue = number | boolean | null | string

export type CaseArr =
    | [string, string, CompareValue, number]
    | [string, CompareValue, number]
    | [CompareValue, number]
    | [number]

export interface SatisfactionRuleCategories {
    [categoryName: string]: {
        [ruleName: string]: CaseArr[]
    }
}

interface State {
    satisfactionRuleCategories: SatisfactionRuleCategories | undefined
}

const initialState: State = {
    satisfactionRuleCategories: undefined,
}

type ReceiveSatisfactionRuleCategoriesAction = {
    type: 'RECEIVE_SATISFACTION_RULE_CATEGORIES'
    satisfactionRuleCategories: SatisfactionRuleCategories
}

export default createReducer(initialState, (builder) =>
    builder.addCase(
        'RECEIVE_SATISFACTION_RULE_CATEGORIES',
        (state, action: ReceiveSatisfactionRuleCategoriesAction) => ({
            ...state,
            satisfactionRuleCategories: action.satisfactionRuleCategories,
        }),
    ),
)
